{
  "blocks": [
    {
      "id": "test-thyroid-panel",
      "kind": "test",
      "tags": ["testing", "her", "pre-cycle", "thyroid"],
      "title": "Thyroid Panel",
      "subtitle": "TSH, T3, and T4 screening for thyroid dysfunction",
      "body": {
        "testName": "Thyroid Panel (TSH/T3/T4)",
        "category": "blood-marker",
        "whatItMeasures": "TSH screens for thyroid dysfunction. Abnormal levels can affect ovulation, implantation, miscarriage risk, and pregnancy outcomes. Free T4 and sometimes free T3 help interpret whether thyroid hormone levels are adequate.",
        "howItWorks": "Simple blood draw, any lab. TSH is the primary screen; T3/T4 are added if abnormal. Ask your clinic whether to pause biotin for 48-72 hours before testing, because it can interfere with some thyroid assays.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood"
          },
          {
            "kind": "time",
            "value": "5 min draw"
          },
          {
            "kind": "pain",
            "value": "Needle pinch"
          },
          {
            "kind": "prep",
            "value": "Ask about pausing biotin"
          },
          {
            "kind": "results",
            "value": "1-3 business days"
          }
        ],
        "turnaroundTime": "1-3 business days",
        "costRange": {
          "low": 30,
          "high": 150
        },
        "atHome": false,
        "clinicRequired": false,
        "cycleDay": "Any cycle day; keep testing conditions consistent and ask about pausing biotin.",
        "markerTiming": [
          {
            "marker": "TSH",
            "timing": "Any cycle day",
            "reason": "TSH is not timed to the menstrual cycle, but consistent testing conditions help interpretation over time. Many fertility clinics aim for a tighter preconception target, commonly below 2.5 mIU/L."
          },
          {
            "marker": "Free T4 / Free T3",
            "timing": "Any cycle day",
            "reason": "Thyroid hormone tests are not cycle-day specific. Biotin can interfere with some thyroid assays, so your clinic may ask you to pause it before testing."
          }
        ],
        "dataPoints": ["dp-tsh-level", "dp-free-t4-level", "dp-free-t3-level"],
        "whyItMatters": [
          "If TSH is elevated, thyroid medication can often bring it into the fertility target range within about 6-8 weeks.",
          "Thyroid antibodies may change how aggressively your clinician monitors thyroid function before and during pregnancy.",
          "This test is not cycle-day specific, so it can be repeated when medication changes or symptoms make retesting useful."
        ],
        "section": "ovarian-reserve"
      },
      "sources": [
        {
          "title": "2017 Guidelines of the American Thyroid Association for the Diagnosis and Management of Thyroid Disease During Pregnancy and the Postpartum",
          "authors": "Alexander EK, Pearce EN, Brent GA, Brown RS, Chen H, Dosiou C, Grobman WA, Laurberg P, Lazarus JH, Mandel SJ, Peeters RP, Sullivan S",
          "journal": "Thyroid",
          "year": 2017,
          "url": "https://pubmed.ncbi.nlm.nih.gov/28056690/",
          "evidenceLevel": "expert-opinion"
        }
      ],
      "readTimeMinutes": 3
    }
  ],
  "relationships": [],
  "localeVariants": []
}
